import { render } from "./cp_chooseDic.vue?vue&type=template&id=6bc4eb3e&scoped=true"
import script from "./cp_chooseDic.vue?vue&type=script&lang=js"
export * from "./cp_chooseDic.vue?vue&type=script&lang=js"

import "./cp_chooseDic.vue?vue&type=style&index=0&id=6bc4eb3e&scoped=scoped&lang=less"

import exportComponent from "H:\\高报云\\HZY\\Code\\HZY.Student\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc4eb3e"]])

export default __exports__